import { initializeApp } from 'firebase/app';
import { getAuth, signInWithEmailAndPassword, signOut, connectAuthEmulator } from 'firebase/auth';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider, CustomProvider } from "firebase/app-check";
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBDh6eYQNC26ye3uxQ5gl8QP-LC36Lc9hw",
  authDomain: "churchaware-8f158.firebaseapp.com",
  projectId: "churchaware-8f158",
  storageBucket: "churchaware-8f158.appspot.com",
  messagingSenderId: "431242702917",
  appId: "1:431242702917:web:b901f3d11c0c5d4d83332c",
  measurementId: "G-K1MGZCBWV3",
  databaseURL: "https://churchaware-8f158.firebaseio.com"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Check if we should use emulators
const useEmulators = process.env.REACT_APP_USE_EMULATORS === 'true';

if (useEmulators) {
  console.log('Connecting to Firebase emulators...');
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectStorageEmulator(storage, '127.0.0.1', 9199);

  // Initialize App Check with a debug provider for emulators
  // This allows functions with enforceAppCheck: true to work in tests
  const debugProvider = new CustomProvider({
    getToken: () => Promise.resolve({
      token: 'emulator-debug-token',
      expireTimeMillis: Date.now() + 3600000, // 1 hour
    }),
  });
  initializeAppCheck(app, { provider: debugProvider, isTokenAutoRefreshEnabled: false });
  console.log('Firebase emulators connected with App Check debug provider.');

  // Expose Firebase instances on window for E2E tests
  window.firebaseDb = db;
  window.firebaseAuth = auth;

  // Expose modular SDK functions for E2E test utilities
  import('firebase/firestore').then(firestore => {
    window.firebaseFirestore = firestore;
  });
} else {
  // Only initialize App Check and Analytics in production
  const analytics = getAnalytics(app);

  try {
    const appCheck = initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider('6LfKASUrAAAAAEoL18pxGiltyG7yhwf3fc8gK_7q'),
      isTokenAutoRefreshEnabled: true
    });
    console.log("Firebase App Check initialized.");
  } catch (err) {
    console.error("Error initializing Firebase App Check:", err);
  }
}

export { signInWithEmailAndPassword, signOut };
export { app, auth, db, storage, functions };
